import React from 'react';
import { IAttendeeDTO, IAttendeeOrganizationDTO } from '../../../../../../api/attendees.dao';
import { IConnectionDetailsDTO } from '../../../../../../api/connections.dao';
import Text from '../../../../../global/text/text';

interface IPropsAttendee extends IAttendeeDTO {
    connection: IConnectionDetailsDTO;
}

interface IPropsAttendeesListItem extends IAttendeeOrganizationDTO {
    attendeeType: string;
    connection: IConnectionDetailsDTO;
    attendees: IPropsAttendee[];
}

const AttendeesListItem = (props: IPropsAttendeesListItem) => {
    const {
        name,
        organizationId,
        attendees,
        attendeeType
    } = props;

    return (
        <div key={organizationId} className='table-list-layout'>
            <div className='meeting-list-item meeting-list-item-row'>
                <Text className='meeting-list-item__header' message={name} withEllipsis />
                <Text className='meeting-list-item__text' message={`, ${attendeeType}`} />
            </div>
            {attendees.map(attendee => {
                const attendeeFullName = `${attendee.firstName} ${attendee.lastName}`;
                const attendeeTitle = attendee.title ? `, ${attendee.title}` : '';

                return (
                    <div className='meeting-list-item meeting-list-item__text' key={attendee.attendeeId}>
                        <Text message={`${attendeeFullName + attendeeTitle}`} withEllipsis />
                    </div>);
            })}
        </div>
    );
};

export { AttendeesListItem };
